// src/plugins/funcionesWC.js
import moment from 'moment';
import { ParamGenerales } from '@/handler/session';

export default {
  install(app) {
    // FECHA
    app.config.globalProperties.$formatDate = function (date) {
      if (!date) return null;
      const formatsToTry = ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601];
      const parsedDate = moment(date, formatsToTry, true);
      return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : null;
    };

    app.config.globalProperties.$setFecha = function (valueDate) {
      if (valueDate) {
        const formatsToTry = ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601];
        const parsedDate = moment(valueDate, formatsToTry, true);
        return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : null;
      } else {
        return null;
      }
    };

    app.config.globalProperties.$setFechaHoy = function () {
      return this.$moment().format('YYYY-MM-DD');
    }

    app.config.globalProperties.$setFechaDefault = function () {
      const today = new Date();
      const firstDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      // Formatea la fecha en el formato "YYYY-MM-DD"
      const formattedDate = firstDayOfPreviousMonth.toISOString().split('T')[0];
      return formattedDate;
    }

    // HORA
    app.config.globalProperties.$setHoraHoy = function () {
      return this.$moment().format('HH:mm');
    }
    app.config.globalProperties.$formatHora = function (hora) {
      if (!hora) return null;
      const formatsToTry = ['HH:mm:ss', 'HH:mm', moment.ISO_8601];
      const parsedHora = moment(hora, formatsToTry, true);
      return parsedHora.isValid() ? parsedHora.format('HH:mm:ss') : null;
    };
    app.config.globalProperties.$formatHoraMinuto = function (hora) {
      if (!hora) return null;
      const formatsToTry = ['HH:mm:ss', 'HH:mm', moment.ISO_8601];
      const parsedHora = moment(hora, formatsToTry, true);
      return parsedHora.isValid() ? parsedHora.format('HH:mm') : null;
    };

    app.config.globalProperties.$setHora = function (hora) {
      if (hora) {
        // Especificar los formatos válidos para parsear la hora
        const formatsToTry = ['HH:mm:ss', 'HH:mm', moment.ISO_8601];
        const parsedHora = moment(hora, formatsToTry, true);
        return parsedHora.isValid() ? parsedHora.format('HH:mm') : null;
      } else {
        return null;
      }
    };

    // NUMBER
    app.config.globalProperties.$formatNumber = function (value, cant_dec = 2) {
      const num = Number(value);
    
      if (isNaN(num)) return 0;
    
      if (cant_dec === null || cant_dec === 0) {
        return Math.trunc(num).toString();
      }
    
      return num.toFixed(cant_dec);
    };
/*    
    app.config.globalProperties.$formatNumber = function (value, cant_dec = 2) {
      if (isNaN(value)) return null;
      if (cant_dec === null || cant_dec === 0) {
        return parseInt(value, 10).toString(); // Formato sin decimales, como entero
      }
      return parseFloat(value).toFixed(cant_dec);
    };
*/
    // Controla si la fecha proporcionada es posterior a la fecha de cierre de los parámetros generales
    app.config.globalProperties.$controlFechaCierre = function (valueDate) {
      const paramGenerales = ParamGenerales.getParamGenerales(); // Obtener parámetros generales
      const fechaCierre = paramGenerales.FECHA_CIERRE; // Obtener la fecha de cierre

      if (!valueDate || !fechaCierre) {
        return false; // Retorna falso si alguna de las fechas no está definida
      }
      // Convertir ambas fechas a moment para comparación
      const fechaComparar = moment(valueDate, 'YYYY-MM-DD');
      const fechaCierreMoment = moment(fechaCierre, 'YYYY-MM-DD');

      // Comparar si la fecha proporcionada es posterior a la fecha de cierre
      return fechaComparar.isAfter(fechaCierreMoment);
    };
  }
};

/**
 * Filtra el menú completo según la búsqueda en los elementos de tipo "I"
 * conservando la jerarquía (M > S > I)
 *
 * @param {Array} menuArray - Array principal del menú.
 * @param {String} busqueda - Cadena de búsqueda.
 * @returns {Array} - Menú filtrado.
 */
function filtrarMenuPorBusqueda(menuArray, busqueda) {
  // Convertir la búsqueda a minúsculas para comparación insensible
  const termino = busqueda.toLowerCase();
  // Recorrer cada elemento de nivel "M"
  return menuArray.reduce((menuFiltrado, menuItem) => {
    // Si el item de nivel M tiene la propiedad "items"
    if (menuItem.items && Array.isArray(menuItem.items)) {
      // Filtrar los submenús (nivel "S")
      const submenusFiltrados = menuItem.items.reduce((subFiltrado, submenu) => {
        // Si el submenu tiene la propiedad "item" (lista de elementos tipo "I")
        if (submenu.item && Array.isArray(submenu.item)) {
          // Filtrar los elementos de tipo "I" que contengan el término buscado
          const itemsFiltrados = submenu.item.filter(i =>
            i.tipo === 'I' && i.nombre.toLowerCase().includes(termino)
          );
          // Si se encontró al menos un item, se agrega el submenu con sus items filtrados
          if (itemsFiltrados.length > 0) {
            subFiltrado.push({
              ...submenu,
              item: itemsFiltrados
            });
          }
        }
        return subFiltrado;
      }, []);

      // Si hay submenús filtrados, se agrega el item de nivel M con dichos submenús
      if (submenusFiltrados.length > 0) {
        menuFiltrado.push({
          ...menuItem,
          items: submenusFiltrados
        });
      }
    }
    return menuFiltrado;
  }, []);
}

// Exportar también la función de filtrado de forma individual
export { filtrarMenuPorBusqueda }
